<template>
  <div class="getting-started-section">
    <h2 class="getting-started-title">Getting Started</h2>
    <!-- Step by Step Guide -->
    <div class="steps-section">
      <div class="step">
        <div class="step-number">1</div>
        <div class="step-content">
          <h2>Install Prec8</h2>
          <AddToSlackButton :openInNewTab="true" />
        </div>
      </div>

      <div class="step">
        <div class="step-number">2</div>
        <div class="step-content">
          <h2>Configure Appreciation Emoji</h2>
          <p>Choose your team's custom emoji for giving recognition. This will be the symbol your team uses to show appreciation.</p>
        </div>
      </div>

      <div class="step">
        <div class="step-number">3</div>
        <div class="step-content">
          <h2>Add @Prec8 to Public Channel</h2>
          <p>Invite @Prec8 to your public Slack channels where team members can give and receive recognition.</p>
        </div>
      </div>

      <div class="step">
        <div class="step-number">4</div>
        <div class="step-content">
          <h2>Give Recognition</h2>
          <p>Use your team's custom emoji to give points to teammates in any Slack channel.</p>
        </div>
      </div>
    </div>

    <!-- Next Steps Section -->
    <div class="next-steps-section">
      <h2>Next Steps</h2>
      <div class="next-steps-grid">
        <div class="next-step">
          <div class="next-step-icon">📊</div>
          <h3>Track Progress</h3>
          <p>Watch your team's appreciation grow with real-time leaderboards and insights.</p>
        </div>
        <div class="next-step">
          <div class="next-step-icon">🎁</div>
          <h3>Redeem Rewards</h3>
          <p>Convert your earned points into real rewards and build a culture of appreciation.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import AddToSlackButton from './AddToSlackButton.vue'

@Options({
  components: {
    AddToSlackButton
  },
})
export default class GettingStarted extends Vue {}
</script>

<style lang="scss" scoped>
.getting-started-section {
  margin-bottom: 4rem;
}

.getting-started-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: #1a1a1a;
  text-align: center;
}

.steps-section {
  display: grid;
  gap: 3rem;
  margin-bottom: 4rem;
}

.step {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 2rem;
  align-items: start;
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #e1e5e9;

  .step-number {
    width: 80px;
    height: 80px;
    border-radius: 40px;
    background: linear-gradient(120deg, #FF6B6B 0%, #FF8E53 100%);
    color: white;
    font-size: 2rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 20px rgba(255, 107, 107, 0.3);
  }

  .step-content {
    h2 {
      font-size: 1.75rem;
      font-weight: 700;
      margin-bottom: 1rem;
      color: #1a1a1a;
    }

    p {
      color: #666;
      line-height: 1.6;
      margin-bottom: 1.5rem;
      font-size: 1.1rem;
    }
  }
}

.next-steps-section {
  background: #f8fafc;
  padding: 3rem 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #e1e5e9;

  h2 {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 2rem;
    color: #1a1a1a;
    text-align: center;
  }

  .next-steps-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
    text-align: center;
  }

  .next-step {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    border: 1px solid #e1e5e9;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    .next-step-icon {
      font-size: 3rem;
      color: #FF6B6B;
      margin-bottom: 1rem;
    }

    h3 {
      font-size: 1.75rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 0.5rem;
    }

    p {
      font-size: 1.1rem;
      color: #666;
      line-height: 1.6;
    }
  }
}

@media (max-width: 768px) {
  .steps-section {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 1rem;

    .step {
      grid-template-columns: 1fr;
      text-align: center;
      gap: 1rem;

      .step-number {
        margin: 0 auto;
      }
    }
  }

  .next-steps-section {
    .next-steps-grid {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }
  }
}
</style> 